import { Button, Spin, Table, Tabs } from 'antd';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import VehicleApi from '../../functions/api/vehicle/VehicleApi';
import MyUtil from '../../functions/MyUtil';
import TableUtils from '../../functions/TableUtils';
import SwitchLuxuryStateButton from './SwitchLuxuryStateButton';

class ListVehicle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listCars: [],
      listMotorbikes: [],
    };
  }

  async componentDidMount() {
    const vehicles = await VehicleApi.getVehicles();

    var listCars = [],
      listMotorbikes = [];

    if (vehicles.length === 0) {
      return;
    }

    vehicles.forEach((item) => {
      if (item.vhc_type_id === 1) {
        listCars.push(item);
      }
      if (item.vhc_type_id === 2) {
        listMotorbikes.push(item);
      }
    });

    this.setState({ listCars, listMotorbikes });
  }

  toggleLuxury = (cell, row) => {
    return <SwitchLuxuryStateButton row={row} />;
  };

  render() {
    const { listCars, listMotorbikes } = this.state;
    if (listCars.length === 0) {
      return <Spin />;
    }
    const canAdd = MyUtil.hasPermission(this.props.match_parent.url, 'add');

    const columnCars = [
      {
        title: 'Mã xe',
        dataIndex: 'vhc_id',
        key: 'vhc_id',
        fixed: 'left',
      },
      {
        title: ' Phiên bản',
        dataIndex: 'vhc_name',
        key: 'vhc_name',
        fixed: 'left',
        ...TableUtils.getColumnDropDownFilter(listCars, 'vhc_name'),
      },
      {
        title: 'Hãng xe',
        dataIndex: 'vhc_bran_name',
        key: 'vhc_bran_name',
        fixed: 'left',
        ...TableUtils.getColumnDropDownFilter(listCars, 'vhc_bran_name'),
      },
      {
        title: 'Dòng xe',
        dataIndex: 'vhc_modl_name',
        key: 'vhc_modl_name',
      },
      {
        title: 'Xi lanh',
        dataIndex: 'vhc_egin_num',
        key: 'vhc_egin_num',
      },
      {
        title: 'Số chỗ',
        dataIndex: 'vhc_seat_num',
        align: 'right',
        render: this.renderVhcSeatNum,
        ...TableUtils.getColumnDropDownFilter(listCars, [['vhc_seat_num']]),
      },
      {
        title: 'Động cơ',
        dataIndex: 'vhc_tms_name',
        ...TableUtils.getColumnDropDownFilter(listCars, [['vhc_tms_name']]),
      },
      {
        title: ' Kiểu dáng',
        dataIndex: 'vhc_dgn_name',
        key: 'vhc_dgn_name',
      },
      {
        title: ' Nhiên liệu',
        dataIndex: 'vhc_fuel_name',
        key: 'vhc_fuel_name',
      },
      {
        title: 'Tiêu hao NL',
        dataIndex: 'vhc_fuel_csum_num',
        key: 'vhc_fuel_csum_num',
      },
      {
        title: 'Hiện xe',
        dataIndex: 'vhc_hide',
        key: 'vhc_hide',
        render: (cell) =>
          cell === 0 ? (
            <i className="far fa-check-circle text-success"></i>
          ) : null,
      },
      {
        title: 'Xe Sang',
        dataIndex: 'vhc_luxury',
        key: 'vhc_luxury',
        render: this.toggleLuxury,
      },
      {
        title: ' Chỉnh sửa',
        render: (row) => (
          <Button
            onClick={() =>
              this.props.history.push(
                `/vehicle-depot/edit-car-depot/${row.vhc_id}`
              )
            }
          >
            <i className="far fa-edit"></i>
          </Button>
        ),
      },
    ];
    const columnMotobike = [
      {
        title: 'Mã xe',
        dataIndex: 'vhc_id',
        key: 'vhc_id',
        fixed: 'left',
      },
      {
        title: ' Phiên bản',
        dataIndex: 'vhc_name',
        key: 'vhc_name',
        fixed: 'left',
        ...TableUtils.getColumnDropDownFilter(listMotorbikes, 'vhc_name'),
      },
      {
        title: 'Hãng xe',
        dataIndex: 'vhc_bran_name',
        key: 'vhc_bran_name',
        fixed: 'left',
        ...TableUtils.getColumnDropDownFilter(listMotorbikes, 'vhc_bran_name'),
      },
      {
        title: 'Động cơ',
        dataIndex: 'vhc_tms_name',
        key: 'vhc_tms_name',
      },
      {
        title: 'Ẩn xe',
        dataIndex: 'vhc_hide',
        key: 'vhc_hide',
        render: (cell) =>
          cell === 0 ? (
            <i className="far fa-check-circle text-success"></i>
          ) : null,
      },
      {
        title: ' Chỉnh sửa',
        dataIndex: '',
        render: this.activeFormatter,
      },
    ];

    return (
      <>
        <h1>Quản lý kho xe</h1>
        <Button
          onClick={() =>
            this.props.history.push(`${this.props.match_parent.url}/add-car`)
          }
          type="primary"
          size="large"
        >
          Thêm
        </Button>
        <Tabs defaultActiveKey="1" centered>
          <Tabs.TabPane tab="Ô tô" key="1">
            <Table
              rowKey="vhc_id"
              size="small"
              columns={columnCars}
              dataSource={listCars}
              scroll={{ x: 'max-content' }}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Xe máy" key="2">
            <Table
              rowKey="vhc_id"
              size="small"
              columns={columnMotobike}
              dataSource={listMotorbikes}
              scroll={{ x: 'max-content' }}
            />
          </Tabs.TabPane>
        </Tabs>
      </>
    );
  }
}

export default withRouter(ListVehicle);
